import { render } from "./projectsSlide2.vue?vue&type=template&id=47104a02&scoped=true"
import script from "./projectsSlide2.vue?vue&type=script&lang=js"
export * from "./projectsSlide2.vue?vue&type=script&lang=js"

import "./projectsSlide2.vue?vue&type=style&index=0&id=47104a02&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47104a02"]])

export default __exports__